<app-login-base [pageHeader]="header">

        <div class="text-center p-5 w-100">                
            <div class="d-flex justify-content-around my-2">                                
                <app-loading [busy]="signOutBusy"></app-loading>                            
            </div>
        </div>      
                   
</app-login-base>